import { Component, inject } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DialogTrackingService } from "../../../services/dialog/dialog-tracking.service";

@Component({
    selector: "app-organization-change-status",
    templateUrl: "./organization-change-status.component.html",
    styleUrls: ["./organization-change-status.component.scss"],
    standalone: false
})
export class OrganizationChangeStatusComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  dialogTrackService = inject(DialogTrackingService);


  public canSubmit(): boolean {
    return true;
  }

  public close(): void {
    this.dialogTrackService.closeDialog(this.ref, null);
  }
}
